import { mapGetters } from 'vuex';
import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import {
  COLOR_INDEXES,
  getColorForPalletteCandidate,
} from '@/components/pages/page-election-map-new/election-map/election-map-constants';
import { isStandalone } from '@/mixins/userAgent';
import Contract from '@/models/contract';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
    },
  },
  components: {
    marketChangePrice,
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile', 'isLayoutDesktop']),
    classModifiers() {
      return {
        'overview-map-contract': true,
        [`overview-map-contract--${this.type}`]: this.type,
      };
    },
    contractModel() {
      return new Contract(this.item);
    },
    color() {
      const pallette = getColorForPalletteCandidate(this.item.shortName);
      return pallette[COLOR_INDEXES.HIGH].color;
    },
    bgColorStyleModifiers() {
      return {
        'background-color': this.color,
      };
    },
    imageStyleModifiers() {
      return {
        'background-image': `url('${this.item.contractImageUrl}')`,
      };
    },
    marketDetailUrl() {
      if (!isStandalone) {
        return this.type === 'senate'
          ? 'https://www.predictit.org/markets/detail/6874'
          : 'https://www.predictit.org/markets/detail/3698';
      }
      return '#';
    },
  },
};
